import React from "react"
import { Input, Button, Table, Space, Select, Form } from 'antd'
import { FormInstance } from "antd/lib/form"
import Modal from "antd/lib/modal/Modal"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import { formItemLayout, tailLayout } from '../../js/globalParam'

const { Column } = Table
const { Option } = Select

interface State {
    data: object[],
    loading: boolean,
    pagination: {
        current: number,
        pageSize: number,
        total: number,
        showSizeChanger: boolean
    },
    fetchOtherParams: {
        star_level_id: string | undefined,
        is_effective: number | undefined
    },
    offShelfVisible: boolean,
    addVisible: boolean,
    detailModalVisible: boolean,
    visibleTitle: string,
    activeRecordID: number | null,
    permissionList: string[],
    starLevelList: object[]
}

export default class CkProjectType extends React.Component {

    state: State = {
        data: [],
        loading: false,
        pagination: {
            current: 1,
            pageSize: 8,
            total: 0,
            showSizeChanger: false
        },
        fetchOtherParams: {
            star_level_id: undefined,
            is_effective: undefined
        },
        offShelfVisible: false,
        addVisible: false,
        detailModalVisible: false,
        visibleTitle: '',
        activeRecordID: null,
        permissionList: [],
        starLevelList: []
    }

    reform = React.createRef<FormInstance>()

    componentDidMount() {
        // 查询标准星级列表
        axiosTable.get("/yuesao_center/global/star_level_list", {

        }).then((response: any) => {
            if (response) {
                this.setState({
                    starLevelList: response
                })
            }
        })

        this.setState({
            permissionList: getPermission()
        })

        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
    }

    handleInputChange(value: any, attr: string) {
        let { fetchOtherParams }: { fetchOtherParams: any } = this.state
        fetchOtherParams[attr] = value

        this.setState({ fetchOtherParams })
    }

    handleSearch() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        this.setState({ pagination }, () => {
            this.fetch({ pagination, fetchOtherParams })
        })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/yuesao_center/config/salary_standard/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                const { pagination } = this.state
                pagination.total = response.total
                pagination.pageSize = response.size
                pagination.current = response.current

                this.setState({
                    pagination,
                    data: response.records
                })
            }
        })
    }

    resetForm() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        fetchOtherParams.star_level_id = undefined
        fetchOtherParams.is_effective = undefined

        this.setState({
            pagination,
            fetchOtherParams
        })

        this.fetch({ pagination, fetchOtherParams })
    }

    showDetail() {
        this.setState({ detailModalVisible: true })
    }

    showAdd() {
        this.setState({ activeRecordID: null, addVisible: true, visibleTitle: '新增标准薪酬' }, () => {
            this.reform.current?.setFieldsValue({ 'star_level_id': '' })
            this.reform.current?.setFieldsValue({ 'base_salary': '' })
            this.reform.current?.setFieldsValue({ 'is_effective': '' })
            this.reform.current?.setFieldsValue({ 'salary_desc': '' })
        })
    }

    showEdit(record: any) {
        baseAxiosNoInfo.get('/yuesao_center/config/salary_standard/detail', { params: { salary_standard_id: record.salary_standard_id } }).then((res: any) => {
            this.setState({ addVisible: true, visibleTitle: '编辑标准薪酬', activeRecordID: record.salary_standard_id }, () => {
                this.reform.current?.setFieldsValue({ 'star_level_id': res.star_level_id })
                this.reform.current?.setFieldsValue({ 'base_salary': res.base_salary })
                this.reform.current?.setFieldsValue({ 'is_effective': res.is_effective })
                this.reform.current?.setFieldsValue({ 'salary_desc': res.salary_desc })
            })
        })
    }

    offShelf() {
        this.setState({ offShelfVisible: true })
    }

    confirmAdd(values: any) {
        let id = this.state.activeRecordID
        let postData: any = {}

        if (id) {
            postData = {
                salary_standard_id: this.state.activeRecordID,
                star_level_id: values.star_level_id,
                base_salary: values.base_salary,
                is_effective: values.is_effective,
                salary_desc: values.salary_desc
            }

        } else {
            postData = {
                star_level_id: values.star_level_id,
                base_salary: values.base_salary,
                is_effective: values.is_effective,
                salary_desc: values.salary_desc
            }
        }

        let url = id ? '/yuesao_center/config/salary_standard/update' : '/yuesao_center/config/salary_standard/add'

        baseAxiosComplete.post(url, postData).then((res: any) => {
            const { pagination, fetchOtherParams } = this.state
            pagination.current = 1

            this.fetch({ pagination, fetchOtherParams })
            this.setState({ addVisible: false })
        })
    }

    render() {
        let { star_level_id, is_effective } = this.state.fetchOtherParams
        let permissionList = this.state.permissionList

        return (<div className="common-page">
            {/* 月嫂中心 -> 月嫂配置 -> 标准薪酬管理 */}
            <BreadCrumb position={['月嫂中心', '标准薪酬管理']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <Select style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="标准星级" showSearch allowClear onChange={(e: any) => { this.handleInputChange(e, 'star_level_id') }} value={star_level_id}
                        filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                    >
                        {this.state.starLevelList.map((el: any) => (<Option value={el.star_level_id} key={el.star_level_id}>{el.star_level_name}</Option>))}
                    </Select>
                    <Select style={{ marginRight: 8, marginBottom: 12, width: '100px' }} placeholder="是否有效" allowClear onChange={(e: number) => { this.handleInputChange(e, 'is_effective') }} value={is_effective} >
                        <Option value={1} key="1">是</Option>
                        <Option value={0} key="0">否</Option>
                    </Select>

                    {permissionList.includes('查询') && <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.handleSearch.bind(this)} >查询</Button>}
                    <Button style={{ marginRight: 5, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    {permissionList.includes('添加') && <Button type="primary" style={{ marginRight: 5, marginBottom: 12 }} onClick={this.showAdd.bind(this)}>添加</Button>}
                </Space>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} rowKey="salary_standard_id" pagination={this.state.pagination} onChange={this.handleTableChange}>
                    <Column title="星级名称" dataIndex="star_level_name" key="star_level_name" />
                    <Column title="基础薪资" dataIndex="base_salary" key="base_salary" />
                    <Column title="薪资描述" dataIndex="salary_desc" key="salary_desc" />
                    <Column title="是否有效" dataIndex="is_effective_desc" key="is_effective_desc" />
                    <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                    <Column title="创建时间" dataIndex="create_time" key="create_time" />
                    <Column title="更新人" dataIndex="update_user_name" key="update_user_name" />
                    <Column title="更新时间" dataIndex="update_time" key="update_time" />

                    <Column
                        title="操作"
                        key="action"
                        render={(text, record) => (
                            <Space size="middle">
                                {permissionList.includes('编辑') && <Button type="link" onClick={this.showEdit.bind(this, record)}>编辑</Button>}
                            </Space>
                        )}
                    />
                </Table>
            </div>

            {/* 月嫂中心 -> 月嫂配置 -> 标准薪酬管理 -> 新增或编辑 */}
            <Modal title={this.state.visibleTitle} visible={this.state.addVisible} footer={false} width="450px" onCancel={() => { this.setState({ addVisible: false }) }}>
                <Form {...formItemLayout} ref={this.reform} name="validate_other" onFinish={this.confirmAdd.bind(this)} >
                    <Form.Item label="标准星级" name="star_level_id" rules={[{ required: true, message: '必须选择标准星级' }]} >
                        <Select virtual={false} showSearch filterOption={(input, option) => (option!.children as unknown as string).includes(input)}>
                            {this.state.starLevelList.map((el: any) => (<Option value={el.star_level_id} key={el.star_level_id}>{el.star_level_name}</Option>))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="基础薪资" name="base_salary" rules={[{ required: true, message: '必须填写基础薪资' }]} >
                        <Input type="number" placeholder="" />
                    </Form.Item>

                    <Form.Item label="是否有效" name="is_effective" rules={[{ required: true, message: '必须选择是否有效' }]} >
                        <Select virtual={false} >
                            <Option value={1} key="1">是</Option>
                            <Option value={0} key="0">否</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="薪资描述" name="salary_desc" rules={[{ required: true, message: '薪资描述' }]} >
                        <Input placeholder="" />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>)
    }
}